//`api/images/all-images:date?${new Date().toJSON()}

import React, { useEffect, useState } from 'react';
import createAuthInterceptor from '../utils/authInterceptor';
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import { Container, Box, Typography, Card, CardMedia, CardContent, IconButton } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel, Pagination } from '@mui/material';

import CardHeader from '@mui/material/CardHeader';
import DeleteIcon from '@mui/icons-material/Delete';
import PlaceIcon from '@mui/icons-material/Place';

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
const { REACT_APP_API_ENDPOINT } = process.env;



function GetAllImages() {
  const navigate = useNavigate();
  const axiosInstance = createAuthInterceptor(navigate);
  const [images, setImages] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [campaignId, setCampaignId] = useState('');
  const [campaigns, setCampaigns] = useState([]);

  const [index, setIndex] = useState(-1);

  const currentImage = images[index];
  const nextIndex = (index + 1) % images.length;
  const nextImage = images[nextIndex] || currentImage;
  const prevIndex = (index + images.length - 1) % images.length;
  const prevImage = images[prevIndex] || currentImage;

  const handleClick = (index, item) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  const [expanded, setExpanded] = React.useState(false);





const handleExpandClick = () => {
  setExpanded(!expanded);
};

  // Per recuperare le campagne disponibili dal backend
  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/campaigns-affissioni-managed-foto`);
        setCampaigns(response.data);
      } catch (error) {
        console.error('Errore nel recupero delle campagne:', error);
      }
    };

    fetchCampaigns();
  }, []);

/*   useEffect(() => {
    const fetchImages = async () => {
      try {

        await axiosInstance.get(`/api/manage/images/all-images`).then((resp) => {
          setImages(resp.data);
       })      
        
      } catch (error) {

        console.error('Errore nel recupero delle immagini:', error);
        // La notifica viene gestita dall'intercettore, quindi non è necessario duplicarla qui
      
      }
    };

    fetchImages();
  }, []); */

  useEffect(() => {
  const fetchImages = async () => {
    if (!campaignId) return; // 🔒 evita il fetch iniziale
    try {
      const res = await axiosInstance.get(`/api/manage/images/all-images`, {
        params: {
          page,
          limit: 12,
          campaignId: campaignId || undefined
        }
      });
      setImages(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error('Errore nel recupero delle immagini:', error);
    }
  };

  fetchImages();
}, [page, campaignId]);


  const handleDelete = async (imageId, index) => {
    try {
      console.log(imageId)
      await axiosInstance.get(`/api/images/delete-image/${imageId}`);
      setImages(images.filter((image) => image._id !== imageId));
      enqueueSnackbar('Immagine eliminata con successo', { variant: 'success' });

    } catch (error) {
      console.error('Errore durante l\'eliminazione dell\'immagine:', error);
    }
  };

  return (
    <Container>
 <Box my={4}>
    <FormControl fullWidth sx={{ mb: 2 }}>
  <InputLabel id="campagna-label">Filtra per Campagna Uffici</InputLabel>
  <Select
    labelId="campagna-label"
    value={campaignId}
    onChange={(e) => {
      setCampaignId(e.target.value);
      setPage(1); // resetta la pagina quando cambia il filtro
    }}
    label="Filtra per Campagna uffici"
  >
    <MenuItem value="">Tutte le Campagne</MenuItem>
    {campaigns.map(c => (
      <MenuItem key={c._id} value={c._id}>{c.denominazione}</MenuItem>
    ))}
  </Select>
</FormControl>
</Box>
{!campaignId ? (
  <Typography variant="body1" sx={{ mt: 2 }}>
    Seleziona una campagna per visualizzare le immagini.
  </Typography>
) : (
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
        Immagini della campagna affissioni selezionata
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          {images.map((image, index) => (
            <Card key={image._id} sx={{ maxWidth: 345, position: 'relative' }}>
            <CardHeader
        avatar={
          <PlaceIcon  aria-label="recipe">
            L
          </PlaceIcon>
        }
        action={
          <IconButton aria-label="settings" sx={{ color: 'red' }} onClick={() => handleDelete(image._id, index)}>
            <DeleteIcon />
          </IconButton>
        }
        title={image?.ufficioPt === '' ? image.depositoPt.recapito : image.ufficioPt.denominazione}
        
      />
              <CardMedia
                component="img"
                height="140"
                image={`${REACT_APP_API_ENDPOINT}/api/${image.path}`}
                alt="Immagine"
                onClick={()=>handleClick(index)}
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  {image.username}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {image.address}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {new Date(image.uploadDate).toLocaleString()}
                </Typography>
                {image.note &&
                    <Typography sx={{ marginBottom: 2 }}>
                  {image.note}
                  </Typography>
                  }
              </CardContent>

            </Card>
          ))}

          {!!currentImage && (
        /* @ts-ignore */
        <Lightbox
          mainSrc={`${REACT_APP_API_ENDPOINT}/api/${currentImage.path}`}
          imageTitle={currentImage.address}
          mainSrcThumbnail={currentImage.path}
          nextSrc={`${REACT_APP_API_ENDPOINT}/api/${nextImage.path}`}
          nextSrcThumbnail={`${REACT_APP_API_ENDPOINT}/api/${nextImage.path}`}
          prevSrc={`${REACT_APP_API_ENDPOINT}/api/${prevImage.path}`}
          prevSrcThumbnail={`${REACT_APP_API_ENDPOINT}/api/${prevImage.path}`}
          onCloseRequest={handleClose}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}

        </Box>
      </Box>
    )}


 <Box my={4} pb={8}>
      <Pagination
      count={totalPages}
      onChange={(e, value) => setPage(value)}
      color="primary"
      sx={{mt: 4}}
      />
</Box>
    </Container>
  );
}

export default GetAllImages;
